import React, { useState } from 'react';
import moment from 'moment';

import ScheduleListItem from './scheduleListItem';

import wpStyles from '../../wordpressStyles';


const ScheduleListItems = ({ ...props }) => {
    if (!props.items || !Array.isArray(props.items) || props.items.length == 0) return <p>Nothing to see here</p>;

    let showDate = false;
    let showTime = false;
    let currentDate = '';
    let currentTime = '';
    const renderedItems = props.items.map((item, i) => {
        showDate = props.hideDate ? false : moment(item.start).format('MM DD') !== currentDate;
        showTime = props.hideTime ? false : moment(item.start).format('h:mma') !== currentTime;
        currentDate = moment(item.start).format('MM DD');
        currentTime = moment(item.start).format('h:mma');
        return item.hidden ? (
            ''
        ) : (
            <li key={i}>
                {showDate || showTime ? (
                    <div>
                        {showDate && (
                            <h3 className="text-xl lg:text-3xl font-bold text-gray-700 pt-8 pb-3">
                                {moment(item.start).format('MMMM Do, YYYY')}
                            </h3>
                        )}
                        {showTime && (
                            <h4 className="text-md lg:text-2xl font-bold text-red-500 pt-4 pb-3" style={wpStyles.textColor1}> 
                                {' '}
                                {moment(item.start).format('h:mma')}
                            </h4>
                        )}
                    </div>
                ) : (
                    ''
                )}
                <ScheduleListItem
                    onButtonClick={() => props.onButtonClick(i)}
                    titleText={item.title}
                    descriptionText={item.description}
                    timeText={`${moment(item.start).format('h:mma')}`}
                    timezoneText="ET"
                    buttonText={item.buttonText}
                    buttonDisabledText={item.buttonDisabledText}
                    buttonDisabled={item.buttonDisabled}
                    buttonToggled={item.buttonToggled}
                    buttonToggleText={item.buttonToggleText}
                    busy={item.busy}
                    hideButton={props.hideButtons}
                    registered={item.registered}
                    hideLabel={true}
                />
            </li>
        );
    });

    return <ul className="flex space-y-2 lg:space-y-4 flex-col">{renderedItems}</ul>;
};

export default ScheduleListItems;
